import { useEffect, useState } from 'react';

export const useCollapsibleColumnTransition = (isCollapsed: boolean) => {
  const [renderState, setRenderState] = useState(isCollapsed);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isCollapsed === renderState) return;

    setIsAnimating(true);

    const timeoutId = window.setTimeout(() => {
      setRenderState(isCollapsed);
      setIsAnimating(false);
    }, 200);

    return () => window.clearTimeout(timeoutId);
  }, [isCollapsed, renderState]);

  return {
    isAnimating,
    showCollapsedLayer: isAnimating || renderState,
    showExpandedLayer: isAnimating || !renderState,
  };
};
